import type { IMatchScheduleItem } from '../../../../../types/schedule';
import { MS_PER_MINUTE } from '../../../../../features/schedule/scheduleOverlap';

export function getMatchEndMs(
  match: IMatchScheduleItem,
  startMs: number,
  dayEndMs: number,
  msPerMinute = MS_PER_MINUTE
): number {
  let endMs = match.scheduleEndDate
    ? new Date(match.scheduleEndDate).getTime()
    : startMs + (match.duration || 20) * msPerMinute;

  if (!Number.isFinite(endMs) || endMs <= startMs) {
    endMs = startMs + (match.duration || 20) * msPerMinute;
  }
  return Math.min(endMs, dayEndMs);
}
